import { all, call, getContext, put, takeEvery } from 'redux-saga/effects';
import type { IChatCenterState } from '../../api/domain';
import type { ChatApiService } from '../../api/services/chat/chat-api-service';
import { fetchChatCenterState, fetchChatCenterStateFailure, fetchChatCenterStateSuccess } from './chat-api-actions';

function* handleFetchChatCenterState() {
    const api: ChatApiService = yield getContext('chatApiService');
    try {
        const state: IChatCenterState = yield call([api, api.getChatCenterState]);
        yield put(fetchChatCenterStateSuccess(state));
    } catch (e: unknown) {
        yield put(fetchChatCenterStateFailure());
    }
}

function* handleFetchChatCenterStateSuccess() {
    yield;
}

export function* chatApiSaga() {
    yield all([takeEvery(fetchChatCenterState, handleFetchChatCenterState), takeEvery(fetchChatCenterStateSuccess, handleFetchChatCenterStateSuccess)]);
}
